import { render, staticRenderFns } from "./modalDetailMasterFreight.vue?vue&type=template&id=7c4d766e&scoped=true&"
import script from "./modalDetailMasterFreight.vue?vue&type=script&lang=js&"
export * from "./modalDetailMasterFreight.vue?vue&type=script&lang=js&"
import style0 from "./modalDetailMasterFreight.vue?vue&type=style&index=0&id=7c4d766e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d766e",
  null
  
)

export default component.exports